import React from 'react';
import _ from 'lodash';

const DivisionCell = ({data, column, meet, style}) => {
  const lifter = data;
  if(lifter.row === 'header') {
    return (
      <div style={style} className="table-cell-inner">
        {column.label}
      </div>
    );
  } else {
    const meetItems = meet.entryConfig.items;
    return (
      <div style={{...style, whiteSpace: 'normal'}} className="table-cell-inner">
        {
          _.map(lifter.restricted.items, (itemId, index) => {
            let item;
            let itemName = "";
            if(typeof itemId === "string") {
              item = _.find(meetItems, {id: itemId});
              itemName = _.get(item, 'name');
              if(!itemName) {
                itemName = 'Not Found';
              }
            } else {
              // new object style
              if(_.get(itemId, 'name')) {
                // take directly from object name
                itemName = _.get(itemId, 'name');
              } else {
                // look up based on id
                item = _.find(meetItems, {id: _.get(itemId, 'id')});
                itemName = _.get(item, 'name');
              }
            }

            return (
              <span key={index}>
                {itemName}{_.size(lifter.restricted.items) !== index+1 && ', '}
              </span>
            );
          })
        }
      </div>
    );
  }
};

export default DivisionCell;
